const PALLET_LABELS: { [key: string]: string } = { one: 'paleta', few: 'palety', many: 'palet' };

export const getPalletLabel = (amount: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(amount);
   return PALLET_LABELS[grammaticalNumber];
};
